import { useState } from 'react'
import { Mic, MicOff, Video, VideoOff } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useOfficeLive } from './OfficeLive'

/**
 * Microphone and camera, off until you turn them on. People nearby with theirs on are heard and seen;
 * with yours off you hear and see no one and no one hears or sees you.
 */
export function MediaButtons({ size = 'sm' }: { size?: 'sm' | 'icon' }) {
  const { mic, cam, setMedia, writes } = useOfficeLive()
  const [busy, setBusy] = useState(false)
  const toggle = async (nextMic: boolean, nextCam: boolean) => {
    setBusy(true)
    try {
      await setMedia(nextMic, nextCam)
    } finally {
      setBusy(false)
    }
  }
  const base = size === 'icon' ? 'size-8 rounded-full p-0' : 'rounded-full'
  return (
    <div className="flex items-center gap-1">
      <Button type="button" size={size === 'icon' ? 'icon' : 'sm'} variant={mic ? 'default' : 'outline'} className={cn(base)} disabled={busy || !writes} aria-pressed={mic} aria-label={mic ? 'Turn microphone off' : 'Turn microphone on'} title={mic ? 'Microphone on: people near you can hear you' : 'Turn on your microphone to talk to people near you'} onClick={() => toggle(!mic, cam)}>
        {mic ? <Mic className="size-4" /> : <MicOff className="size-4" />}
        {size === 'sm' ? <span>{mic ? 'Mic on' : 'Mic'}</span> : null}
      </Button>
      <Button type="button" size={size === 'icon' ? 'icon' : 'sm'} variant={cam ? 'default' : 'outline'} className={cn(base)} disabled={busy || !writes} aria-pressed={cam} aria-label={cam ? 'Turn camera off' : 'Turn camera on'} title={cam ? 'Camera on: people near you can see you' : 'Turn on your camera so people near you can see you'} onClick={() => toggle(mic, !cam)}>
        {cam ? <Video className="size-4" /> : <VideoOff className="size-4" />}
        {size === 'sm' ? <span>{cam ? 'Camera on' : 'Camera'}</span> : null}
      </Button>
    </div>
  )
}
